import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fathomAnalytics = defineConnector({
  identifier: "fathomAnalytics",
  name: "Fathom Analytics",
  tagLine: "Privacy-first web analytics",
  keywords: "fathom",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.usefathom\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Settings > API](https://app.usefathom.com/api) in Fathom and create a new API token with access to all sites (tokens scoped to a single site fail the connection test).",
        },
      ],
    },
    {
      title: "Copy and paste the API token into the field below",
      items: [
        {
          kind: "input",
          label: "Fathom API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.usefathom.com/v1/sites",
  },
});
